/**
 * SxaAssessmentPortraitTile.js
 *
 * Copyright (c) 2018-2019 i-Solutions Global Ltd. All Rights Reserved.
 *
 * This software is the confidential and proprietary information of
 * i-Solutions Global Ltd. ("Confidential Information").  You shall
 * not disclose such Confidential Information and shall use it only in
 * accordance with the terms of the license agreement you entered into
 * with i-Solutions Global Ltd.
 *
 * I-SOLUTIONS GLOBAL LTD MAKES NO REPRESENTATIONS OR WARRANTIES ABOUT
 * THE SUITABILITY OF THE SOFTWARE, EITHER EXPRESS OR IMPLIED, INCLUDING BUT NOT
 * LIMITED TO THE IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
 * PARTICULAR PURPOSE, OR NON-INFRINGEMENT. I-SOLUTIONS GLOBAL LTD SHALL NOT BE
 * LIABLE FOR ANY DAMAGES SUFFERED BY LICENSEE AS A RESULT OF USING, MODIFYING OR
 * DISTRIBUTING THIS SOFTWARE OR ITS DERIVATIVES.
 *
 * Version 1.0
 */

import React from 'react';
import PropTypes from "prop-types";

import {withStyles} from "@material-ui/core";
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';

import CssBaseline from '@material-ui/core/CssBaseline';
import AppBar from '@material-ui/core/AppBar';
//import Toolbar from '@material-ui/core/Toolbar';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import axios from "axios";

import StratexAssessLogoPlus from "./images/stratex_assess_logo_tag.svg";
import LinkedInIcon from "./images/inx_linkedin.svg";
import FacebookIcon from "./images/inx_facebook.svg";
import YouTubeIcon from "./images/inx_youtube.svg";
import TwitterIcon from "./images/inx_twitter.svg";

import SxaAssessmentNarrowTile from "./SxaAssessmentNarrowTile";
import SxaAssessmentStartTile from "./SxaAssessmentStartTile";
import SxaAssessmentFinishTile from "./SxaAssessmentFinishTile";

// custom font styles
const theme = createMuiTheme({
    typography: {
        useNextVariants: true,
        // Use the system font instead of the default Roboto font.
        fontFamily: [
            'Open Sans, sans-serif',
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            'Roboto',
            '"Helvetica Neue"',
            'Arial',
            'sans-serif',
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(','),
        //button: {
        //    fontStyle: 'italic',
        //},
    },
});

const styles = theme => ({
    appBarBottom: {
        top: 'auto',
        bottom: 0,
    },
    toolbar: {
        alignItems: 'center',
        justifyContent: 'space-between',
    },
});

class SxaAssessmentPortraitTile extends React.Component {
    constructor(props) {
        super(props);

        console.log("Assessment Portrait init; ass = " + props.ass.oid +
            "; current Q = " + props.ass.currentQuestion.oid);

        // Assign A ref to state for refresh
        this.state = { ass: props.ass,
            progstate: props.ass.progressState,
            finished: false,
            currQOrdinal: props.ass.currentQuestion.masterOrdinal,
            totalQCount: props.ass.currentQuestion.totalQCount
        };
    }

    componentDidMount() {
        // Check Assessment state and open the Modal start
        //console.log("A-Portrait.componentDidMount(): decide Start open A state = " +
        //    this.state.ass.progressState);

        document.body.style.backgroundColor = "white";

        // Call down to narrow tile to handle any Q change
        if (this.bod) {
            this.bod.handleQChange(this.state.ass.currentQuestion);
        }
    }

    // Callback function used by child to signal A Start
    signalStart = () => {
        // Pre-Condition:
        // (A) progstate is NOT_STARTED - defensive

        //console.log("A-Portrait.signalStart()");

        // Signal up to Root tile
        // No single root for orientation - portrait is root UFN

        var url = 'api/assessment/start';
        axios.get(url)
            .then(response => {
                // Handle A-state change - callback function
                console.log("Assessment START server call completed");

                var newA = response.data;

                //console.log(newA);
                this.setState({ ass: newA});
                // Use function callback version ?
                //this.setState( state => ({ ass: newA }) );

                console.log("setState() call completed with new A");

                // Signal new A state on App (real root)
                // so that e.g. switch to portrait mode picks up the correct A state (Started...)
                this.props.signalAChange(newA);
            })
            .catch(err => console.error(err))
    }

    // Callback function used by child to signal A Finish
    signalFinish = () => {
        // Pre-Condition:
        // (A) progstate is PENDING - defensive

        console.log("Assessment_Portrait.signalFinish()");

        this.setState( { finished: true});
    }

    // Callback function used by child to signal Finish exit
    signalFinishExit = () => {
        //console.log("Assessment_Portrait.signalFinishExit()");

        this.setState( { finished: false});
    }

    // Callback function used by child to signal Q-score change
    signalScoreChange = () => {
        //console.log("Assessment_Portrait.signalScoreChange()");

        // Update the Assessment results tile to reflect the new score
        // Get the updated A state
        var url = 'api/assessment';
        axios.get(url)
            .then(response => {
                var freshA = response.data;
                //console.log(freshA);
                this.setState({ ass: freshA });

                // if assessment is completed then need to signal nav tile to refresh button state
                if (freshA.currentQuestion.assCompleted === true) {
                    console.log("Signal nav tile re. A completed");
                    this.bod.handleCompleted();
                }

                // Update the result tile - call using ares reference
                // FIXME - remove this call unless Results is added to portrait as a drawer
                //this.ares.updateResults(this.state.ass);
            })
            .catch(error => {
                console.error(error)
            })
    };

    // Callback function used by children to signal Q change (e.g. nav back or next, PA or D select)
    signalQChange = (q) => {
        // Debug trace
        //console.log("Assessment_Portrait.signalQChange(); new Q = " + q.oid +
        //    "; PA id = " + q.paId +
        //    "; D id = " + q.dId
        //);

        // Update the X of Y state in the AppBar header
        this.setState( state => ({ currQOrdinal: q.masterOrdinal, totalQCount: q.totalQCount }));

        // Update the landscape A
        var currA = this.state.ass;
        currA.currentQuestion = q;
        currA.currentProcessAreaID = q.paId;
        currA.currentDimensionID = q.dId;

        this.setState({ ass: currA} );
    }

    render() {
        const { classes } = this.props;
        return(
            <MuiThemeProvider theme={theme}>
                <React.Fragment>
                <CssBaseline />
                    {this.state.ass ? (
                        <div>
                            <AppBar position="static" style={{ backgroundColor: "#1e2b56", minHeight: 50}} >
                                <Grid container spacing={0} direction="row" justify="space-evenly" alignItems="stretch"
                                      style={{ paddingLeft: 12, paddingRight: 12}} >
                                    <Grid item xs={6} sm={6} lg={6} xl={6} align="left">
                                        <img src={StratexAssessLogoPlus} alt="Logo" height="36" align="left"
                                             style={{ marginTop: '0.5em'}}/>
                                    </Grid>
                                    <Grid item xs={6} sm={6} lg={6} xl={6} align="right">
                                        <Typography align="right" color="inherit"
                                                    style={{ fontSize: 15, marginTop: '1.0em', paddingRight: 6 }}>
                                            {this.state.currQOrdinal} of {this.state.totalQCount}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </AppBar>
                            {this.state.ass.progressState === "NOT_STARTED" ?
                                <SxaAssessmentStartTile progstate={this.state.progstate}
                                                        signalStart={this.signalStart}
                                />
                                :
                                ""
                            }
                            {this.state.finished ?
                                <SxaAssessmentFinishTile ass={this.state.ass}
                                                         signalFinishExit={this.signalFinishExit}
                                />
                                :
                                ""
                            }
                            {this.state.ass.progressState !== "NOT_STARTED" &&
                            this.state.finished !== true?
                                <SxaAssessmentNarrowTile ass={this.state.ass}
                                                         ref={(bod) => { this.bod = bod; }}
                                                         signalScoreChange={this.signalScoreChange}
                                                         signalFinish={this.signalFinish}
                                                         signalQChange={this.signalQChange}
                                />
                                :
                                ""
                            }
                            <AppBar position="fixed" color="primary" className={classes.appBarBottom}>
                                <div align="center" style={{ backgroundColor: "#1e2b56", minHeight: 30}} >
                                    <Grid container spacing={0} direction="row" justify="space-evenly" alignItems="stretch">
                                        <Grid item xs={3} sm={3} lg={3} xl={3} align="left">
                                            <a href="https://www.i-nexus.com/privacy-policy" target="_blank"
                                               rel="noopener noreferrer" style={{ color: "#6e8cc4", textDecoration: 'none' }}>
                                                <Typography variant="inherit" color="inherit" align="left"
                                                            style={{
                                                                fontSize: 12, paddingTop: 10,
                                                                color: "#6e8cc4",
                                                                paddingLeft: '1.0em',
                                                                fontFamily: 'Open Sans, sans-serif'
                                                            }}>
                                                    Privacy
                                                </Typography>
                                            </a>
                                        </Grid>
                                        <Grid item xs={4} sm={4} lg={4} xl={4}>
                                            <Grid container spacing={0} direction="row" justify="center" alignItems="center"
                                                  style={{marginTop: 0}}>
                                                <Grid item xs={2} sm={2} lg={2} xl={2}>
                                                </Grid>
                                                <Grid item xs={2} sm={2} lg={2} xl={2}>
                                                    <Typography variant="inherit" color="inherit" align="right"
                                                                style={{fontSize: 10, padding: '1.0em', color: "white"}}>
                                                        <a href="https://www.linkedin.com/company/i-nexus" target="_blank"
                                                           rel="noopener noreferrer">
                                                            <img src={LinkedInIcon} alt="Twitter" align="center" height="20px"/>
                                                        </a>
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={2} sm={2} lg={2} xl={2}>
                                                    <Typography variant="inherit" color="inherit" align="right"
                                                                style={{fontSize: 10, padding: '1.0em', color: "white"}}>
                                                        <a href="https://www.youtube.com/channel/UC8_S43QeT_b5PusmTiig-uw"
                                                           target="_blank"
                                                           rel="noopener noreferrer">
                                                            <img src={YouTubeIcon} alt="Twitter" align="center" height="20px"/>
                                                        </a>
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={2} sm={2} lg={2} xl={2}>
                                                    <Typography variant="inherit" color="inherit" align="right"
                                                                style={{fontSize: 10, padding: '1.0em', color: "white"}}>
                                                        <a href="https://twitter.com/inexus_software" target="_blank"
                                                           rel="noopener noreferrer">
                                                            <img src={TwitterIcon} alt="Twitter" align="center" height="20px"/>
                                                        </a>
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={2} sm={2} lg={2} xl={2}>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={5} sm={5} lg={5} xl={5} align="right">
                                            <Typography variant="inherit" color="inherit" align="right"
                                                        style={{
                                                            fontSize: 12,
                                                            fontFamily: 'Open Sans, sans-serif',
                                                            paddingTop: 10,
                                                            paddingRight: '1.0em',
                                                            color: "#6e8cc4"
                                                        }}>
                                                © 2019 i-nexus Global plc
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </div>
                            </AppBar>
                        </div>
                    ) : "No Assessment found"}
                </React.Fragment>
            </MuiThemeProvider>
        )
    }
}

SxaAssessmentPortraitTile.propTypes = {
    classes: PropTypes.object.isRequired,
};

/* FB icon removed Nov-2019
<Grid item xs={2} sm={2} lg={2} xl={2}>
<Typography variant="inherit" color="inherit" align="right"
style={{fontSize: 10, padding: '1.0em', color: "white"}}>
<a href="https://www.facebook.com/inexussoftware/" target="_blank"
rel="noopener noreferrer">
<img src={FacebookIcon} alt="Twitter" align="center" height="20px"/>
</a>
</Typography>
</Grid>
*/

export default withStyles(styles)(SxaAssessmentPortraitTile);